module.exports = __webpack_public_path__ + "img/31-achieving-a-socially-equitable.c6f82d06.jpg";